import React from "react";
import { Descriptions, Typography } from "antd";

const { Title } = Typography;

const GeoNearMe = ({ resource }) => (
  <>
    <Title level={4}>Order Information</Title>
    <Descriptions column={1} layout="vertical" size="small">
      <Descriptions.Item label="Product Subscription ID ">{resource.product_subscription_id}</Descriptions.Item>
      <Descriptions.Item label="Business Name">{resource.business_name}</Descriptions.Item>
      <Descriptions.Item label="Business Address">{resource.business_address}</Descriptions.Item>
      <Descriptions.Item label="Business GMB CID">{resource.business_gmb_cid}</Descriptions.Item>
      <Descriptions.Item label="Campaign Name">{resource.campaign_name}</Descriptions.Item>
      <Descriptions.Item label="Category Keywords">{resource.category_keywords}</Descriptions.Item>
      <Descriptions.Item label="Service Keywords">{resource.service_keywords}</Descriptions.Item>
      <Descriptions.Item label="Client Name">{resource.client_name}</Descriptions.Item>
      <Descriptions.Item label="Website URL">{resource.website_url}</Descriptions.Item>
      <Descriptions.Item label="Notes">{resource.notes}</Descriptions.Item>
      <Descriptions.Item label="Agreement">
          {resource.agreement &&
            <a target="_blank" href={resource.agreement.url}>
              {resource.agreement.name}
            </a>
          }
        </Descriptions.Item>
    </Descriptions>
  </>
);

export default GeoNearMe;

